import { motion } from "framer-motion";

const stats = [
  { v: "5,400+", l: "Videos created" },
  { v: "98.4%", l: "On-time in 24h" },
  { v: "42M+", l: "Total views driven" },
  { v: "4.9/5", l: "Avg. brand rating" },
];

const testimonials = [
  { q: "We went from 0 to 310k views on our first reel. The turnaround is genuinely 24 hours — insane.", n: "Priya S.", r: "Founder, Glow Skincare" },
  { q: "I just pasted our product URL and got a scroll-stopping reel the next morning. No briefs, no calls.", n: "Marcus L.", r: "Growth, FitFuel" },
  { q: "The hooks they write convert. Our CTR from Instagram doubled in two weeks.", n: "Aisha K.", r: "CMO, NovaCart" },
];

export const Trust = () => (
  <section className="py-16 lg:py-24 bg-[#0C0D14]">
    <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-12">
      <div data-testid="trust-stats-bar" className="grid grid-cols-2 lg:grid-cols-4 gap-4">
        {stats.map((s) => (
          <div key={s.l} className="rounded-2xl bg-[#12141C] border border-white/10 p-6 text-center">
            <p className="font-mono text-3xl sm:text-4xl font-bold text-[#FF2E63]">{s.v}</p>
            <p className="mt-1 text-sm text-slate-400">{s.l}</p>
          </div>
        ))}
      </div>

      <div data-testid="testimonials-carousel" className="mt-12 grid md:grid-cols-3 gap-5">
        {testimonials.map((t, i) => (
          <motion.figure key={t.n}
            initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}
            transition={{ duration: 0.4, delay: i * 0.1 }}
            className="rounded-2xl bg-[#12141C] border border-white/10 p-7">
            <div className="text-[#00F5D4] text-lg">★★★★★</div>
            <blockquote className="mt-3 text-slate-200 leading-relaxed">“{t.q}”</blockquote>
            <figcaption className="mt-5 text-sm">
              <span className="font-semibold text-white">{t.n}</span>
              <span className="text-slate-500"> · {t.r}</span>
            </figcaption>
          </motion.figure>
        ))}
      </div>
    </div>
  </section>
);
